import APICampaign2 from 'api/statistics/campaign/v2'
import omit from 'lodash/omit'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import prepareFilterParams from 'utils/prepareFilterParams'
import { notificationShow } from 'modules/Notifications/actions'

function* statisticsFetchChart({ payload }) {
  try {
    const filtersState = yield select((state) => ({
      ...state['statistics/filters'].filters,
      ...state['statistics/campaign'].filters,
    }))

    const params = omit(prepareFilterParams(filtersState), [
      'include_vat',
      'networks',
    ])

    yield put({
      type: 'STATISTICS/CAMPAIGN_FETCH_CHART_START',
      payload: 'chart',
    })

    let METHOD

    switch (payload.network) {
      case 'yd':
        METHOD = APICampaign2.fetchChart
        break
      default:
        throw new Error('network type not supported')
    }

    const { response, error } = yield call(METHOD, {
      params: params,
      ...payload,
    })

    if (error) {
      throw error
    }

    const { items, summary, pagination } = response.data

    yield put({
      type: 'STATISTICS/CAMPAIGN_SET_CHART',
      payload: { data: items, summary, pagination },
    })
  } catch (error) {
    yield put({ type: 'STATISTICS/CAMPAIGN_FETCH_FAIL', payload: 'chart' })
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  }
}

function* fetchStatisticsTable({ payload }) {
  try {
    const { limit, offset, network } = payload
    yield put({
      type: 'STATISTICS/CAMPAIGN_FETCH_TABLE_START',
      payload: 'table',
    })

    const filtersState = yield select((state) => ({
      ...state['statistics/filters'].filters,
      ...state['statistics/campaign'].filters,
    }))

    const params = {
      ...omit(prepareFilterParams(filtersState), ['include_vat', 'networks']),
      limit,
      offset,
    }

    let METHOD

    switch (network) {
      case 'yd':
        METHOD = APICampaign2.fetchAds
        break
      default:
        throw new Error('network type not supported')
    }

    const { response, error } = yield call(METHOD, {
      params: params,
      ...payload,
    })

    if (error) {
      throw error
    }

    const { items, summary, pagination } = response.data

    yield put({
      type: 'STATISTICS/CAMPAIGN_SET_TABLE',
      payload: { data: items, summary, pagination },
    })
  } catch (error) {
    yield put({ type: 'STATISTICS/CAMPAIGN_FETCH_FAIL', payload: 'table' })
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  }
}

export default function* Sagas() {
  yield takeLatest('STATISTICS/CAMPAIGN_FETCH_CHART', statisticsFetchChart)
  yield takeLatest('STATISTICS/CAMPAIGN_FETCH_TABLE', fetchStatisticsTable)
}
